/*
 * FANNUR — Palo Alto Theme
 *
 * Fix for Canvas sizes:
 * - 100 x 150 cm
 * - 150 x 100 cm
 *
 * Automatically selects 4 cm when either size is chosen.
 * Keeps those sizes selectable in the Size dropdown.
 * Shows only 4 cm in the Depth dropdown for these sizes.
 *
 * Does not affect other sizes, Poster products,
 * frame configurator or cart functionality.
 *
 * Load only on product pages via layout/theme.liquid.
 */

(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-product]';

  var SIZE_SELECTOR =
    '[data-selector-wrapper][data-option-position="1"]';

  var DEPTH_SELECTOR =
    '[data-selector-wrapper][data-option-position="2"]';

  var contexts = new WeakMap();

  /* =========================================
     HELPERS
  ========================================= */

  // Functie: normalizeSize — Normaliseert formaattekst naar hetzelfde formaat voor vergelijkingen.
  function normalizeSize(value) { return String(value || '') .toLowerCase() .replace(/cm/g, '') .replace(/[×x]/g, 'x') .replace(/\s+/g, ''); }

  // Functie: isLargeSize — Controleert of de gekozen maat 100x150 of 150x100 cm is.
  function isLargeSize(value) { var size = normalizeSize(value); return ( size === '100x150' || size === '150x100' ); }

  // Functie: isFourCm — Controleert of een dieptewaarde overeenkomt met 4 cm.
  function isFourCm(value) { return /^4\s*cm$/i.test( String(value || '').trim() ); }

  /* =========================================
     FIND PRODUCT CONTEXT
  ========================================= */

  // Functie: getContext — Zoekt productformulier, keuzelijsten en geldige Shopify-varianten.
  function getContext(element) { var root = element && element.closest(ROOT_SELECTOR); if (!root) return null; if (contexts.has(root)) { return contexts.get(root); } var form = root.querySelector( 'form[data-product-form]' ); var json = root.querySelector( '[data-product-json]' ); if (!form || !json) return null; var sizeWrapper = form.querySelector( SIZE_SELECTOR ); var depthWrapper = form.querySelector( DEPTH_SELECTOR ); if (!sizeWrapper || !depthWrapper) { return null; } var product; try { product = JSON.parse(json.textContent); } catch (error) { return null; } if ( !product || !Array.isArray(product.variants) ) { return null; } var sizeField = sizeWrapper.querySelector( '[data-popout-input][data-single-option-selector]' ); var depthField = depthWrapper.querySelector( '[data-popout-input][data-single-option-selector]' ); if (!sizeField || !depthField) { return null; } /* Only products with a purchasable large 4 cm variant. */ /* Posters and other product types are ignored. */ var hasLargeFourCm = product.variants.some( function (variant) { return ( variant.available && variant.options && isLargeSize(variant.options[0]) && isFourCm(variant.options[1]) ); } ); if (!hasLargeFourCm) { return null; } var context = { root: root, sizeWrapper: sizeWrapper, depthWrapper: depthWrapper, sizeField: sizeField, depthField: depthField, variants: product.variants }; contexts.set(root, context); return context; }

  /* =========================================
     CHECK FOUR-CM AVAILABILITY
  ========================================= */

  // Functie: availableInFour — Controleert of een grote maat beschikbaar is met 4 cm diepte.
  function availableInFour(context, size) { var target = normalizeSize(size); if (!isLargeSize(target)) { return false; } return context.variants.some( function (variant) { return ( variant.available && variant.options && normalizeSize(variant.options[0]) === target && isFourCm(variant.options[1]) ); } ); }

  /* =========================================
     UPDATE DEPTH DROPDOWN DISPLAY
  ========================================= */

  // Functie: updateDepthDisplay — Toont 4 cm als huidige diepte in de keuzelijst.
  function updateDepthDisplay(context) { var wrapper = context.depthWrapper; var label = wrapper.querySelector( '[data-popout-text]' ); if (label) { label.textContent = '4 cm'; } wrapper.querySelectorAll( '[data-popout-option]' ).forEach(function (option) { var current = isFourCm( option.getAttribute('data-value') ); if (current) { option.setAttribute( 'aria-current', 'true' ); } else { option.removeAttribute( 'aria-current' ); } var item = option.closest( '.select-popout__item' ); if (item) { item.classList.toggle( 'select-popout__item--current', current ); } }); }

  /* =========================================
     UPDATE SIZE & DEPTH VISIBILITY
  ========================================= */

  // Functie: synchronize — Synchroniseert beschikbaarheid van formaten en zichtbaarheid van dieptes.
  function synchronize(context) { /* Keep 100x150 and 150x100 selectable */ /* when their 4 cm variant is available. */ context.sizeWrapper.querySelectorAll( '[data-popout-option]' ).forEach(function (option) { var value = option.getAttribute( 'data-value' ); if (!isLargeSize(value)) { return; } var item = option.closest( '.select-popout__item' ); if (!item) return; var available = availableInFour( context, value ); item.classList.toggle( 'fnr-large-available', available ); if (available) { item.classList.remove( 'unavailable', 'sold-out' ); } }); /* If large size is selected, hide 2 cm. */ /* For all other sizes, restore original choices. */ var selectedIsLarge = availableInFour( context, context.sizeField.value ); context.depthWrapper.querySelectorAll( '[data-popout-option]' ).forEach(function (option) { var item = option.closest( '.select-popout__item' ); if (!item) return; var hide = ( selectedIsLarge && !isFourCm( option.getAttribute('data-value') ) ); item.classList.toggle( 'fnr-hide-depth-option', hide ); }); }

  /* =========================================
     HANDLE REAL SIZE SELECTION
  ========================================= */

  // Event: theme:popout:click — Bij formaatselectie stelt de correcte 4 cm-diepte in vóór thema-afhandeling.
  document.addEventListener( 'theme:popout:click', function (event) { var option = event.target.closest && event.target.closest( '[data-popout-option]' ); if (!option) return; var wrapper = option.closest( SIZE_SELECTOR ); if (!wrapper) return; var context = getContext(wrapper); if ( !context || context.sizeWrapper !== wrapper ) { return; } var chosenSize = option.getAttribute( 'data-value' ); /* Apply only to the two target sizes, */ /* and only if a 4 cm variant is for sale. */ if (!availableInFour( context, chosenSize )) { return; } if (isFourCm(context.depthField.value)) { return; } /* * Set Depth silently before Palo Alto * processes the real Size selection. * * No synthetic clicks. * No synthetic change events. * No repeated variant updates. * * The original Size selection triggers * the theme's normal variant handling. */ context.depthField.value = '4 cm'; updateDepthDisplay(context); }, true );

  /* =========================================
     LISTEN TO NORMAL THEME VARIANT UPDATE
  ========================================= */

  // Event: theme:variant:change — Synchroniseert diepteopties na een normale variantwijziging.
  document.addEventListener( 'theme:variant:change', function (event) { var context = getContext(event.target); if (!context) return; synchronize(context); } );

  /* =========================================
     INITIALIZATION
  ========================================= */

  // Functie: init — Initialiseert de formaat- en dieptekeuzes voor productsecties.
  function init() { document.querySelectorAll( ROOT_SELECTOR ).forEach(function (root) { var context = getContext(root); if (context) { synchronize(context); } }); }

  if (document.readyState === 'loading') {

    // Event: DOMContentLoaded — Start de bijbehorende module zodra de DOM gereed is.
    document.addEventListener( 'DOMContentLoaded', init, { once: true } );

  } else {

    init();

  }

  // Event: shopify:section:load — Herinitialiseert na laden van een Shopify-sectie.
  document.addEventListener( 'shopify:section:load', init );

  /* =========================================
     CSS — ONLY AFFECT RELEVANT OPTIONS
  ========================================= */

  var style = document.createElement('style');

  style.textContent = [
    '.fnr-large-available,',
    '.fnr-large-available .select-popout__option,',
    '.fnr-large-available .select-popout__option span {',
    '  text-decoration: none !important;',
    '  opacity: 1 !important;',
    '  pointer-events: auto !important;',
    '  cursor: pointer !important;',
    '}',

    '.fnr-hide-depth-option {',
    '  display: none !important;',
    '}'
  ].join('\n');

  document.head.appendChild(style);

})();